import { API_CALL } from '../../../middleware/api';

export const GET_ATHENA_CONFIGURATION = 'GET_ATHENA_CONFIGURATION';
export const GET_ATHENA_CONFIGURATION_RESULT = `${GET_ATHENA_CONFIGURATION}/result`;
export const GET_ATHENA_CLAIM_SUBMISSIONS = 'GET_ATHENA_CLAIM_SUBMISSIONS';
export const GET_ATHENA_CLAIM_SUBMISSIONS_RESULT = `${GET_ATHENA_CLAIM_SUBMISSIONS}/result`;
export const GET_ATHENA_CLAIM_HISTORY = 'GET_ATHENA_CLAIM_HISTORY';
export const GET_ATHENA_CLAIM_HISTORY_RESULT = `${GET_ATHENA_CLAIM_HISTORY}/result`;
export const RESUME_ATHENA_CLAIM_POLLING = 'RESUME_ATHENA_CLAIM_POLLING';
export const RESUME_ATHENA_CLAIM_POLLING_RESULT = `${RESUME_ATHENA_CLAIM_POLLING}/result`;

export const SET_ATHENA_CREDENTIALS = 'SET_ATHENA_CREDENTIALS';
export const SET_ATHENA_CREDENTIALS_RESULT = `${SET_ATHENA_CREDENTIALS}/result`;

export const SET_ATHENA_PRACTICE = 'SET_ATHENA_PRACTICE';
export const SET_ATHENA_PRACTICE_RESULT = `${SET_ATHENA_PRACTICE}/result`;

export const SET_ATHENA_REFERRING_PROVIDER_MAPPING = 'SET_ATHENA_REFERRING_PROVIDER_MAPPING';
export const SET_ATHENA_REFERRING_PROVIDER_MAPPING_RESULT = `${SET_ATHENA_REFERRING_PROVIDER_MAPPING}/result`;
export const SET_ATHENA_CLINICIAN_PROVIDER_MAPPING = 'SET_ATHENA_CLINICIAN_PROVIDER_MAPPING';
export const SET_ATHENA_CLINICIAN_PROVIDER_MAPPING_RESULT = `${SET_ATHENA_CLINICIAN_PROVIDER_MAPPING}/result`;

export const actions = {
  getConfiguration: organizationId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/configuration`,
    },
    type: GET_ATHENA_CONFIGURATION,
  }),

  getClaimSubmissions: (organizationId, cursor) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/claim-submissions?limit=50${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`,
    },
    type: GET_ATHENA_CLAIM_SUBMISSIONS,
  }),

  getClaimSubmissionHistory: (organizationId, submissionId, cursors = {}) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/claim-submissions/history?${new URLSearchParams({ submissionId, limit: 50, ...cursors })}`,
    },
    type: GET_ATHENA_CLAIM_HISTORY,
  }),

  resumeClaimPolling: (organizationId, submissionId) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/claim-submissions/resume-polling`,
      data: { submissionId },
    },
    type: RESUME_ATHENA_CLAIM_POLLING,
  }),

  setCredentials: (organizationId, credentials) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/credentials`,
      data: credentials,
    },
    type: SET_ATHENA_CREDENTIALS,
  }),

  setPractice: (organizationId, practice) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/practices`,
      data: practice,
    },
    type: SET_ATHENA_PRACTICE,
  }),

  setReferringProviderMapping: (organizationId, mapping) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/referring-provider-mappings`,
      data: mapping,
    },
    type: SET_ATHENA_REFERRING_PROVIDER_MAPPING,
  }),
  setClinicianProviderMapping: (organizationId, mapping) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/athena/${organizationId}/clinician-provider-mappings`,
      data: mapping,
    },
    type: SET_ATHENA_CLINICIAN_PROVIDER_MAPPING,
  }),
};
